// src/features/account/profileMapper.js
import { getImageUrl } from "../../services/api";

/**
 * Safely convert any birthdate value to "YYYY-MM-DD".
 * Guards against: JS Date objects, ISO strings ("2005-10-10T00:00:00.000Z"),
 * plain strings ("2005-10-10"), and nullish values.
 */
function toBirthdateString(raw) {
  if (!raw) return "";
  // Plain object (e.g. {} from broken serialization) → discard
  if (typeof raw === "object" && !(raw instanceof Date)) return "";
  // JS Date instance
  if (raw instanceof Date) {
    const y = raw.getUTCFullYear();
    const m = String(raw.getUTCMonth() + 1).padStart(2, "0");
    const d = String(raw.getUTCDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
  }
  // String — extract the YYYY-MM-DD portion (handles ISO strings too)
  const match = String(raw).match(/(\d{4}-\d{2}-\d{2})/);
  return match ? match[1] : "";
}

export function pickProfileFromMe(me) {
  // helper to read possibly-nested response objects
  const u = me || {};

  return {
    firstName: u?.firstName ?? u?.first_name ?? "",
    lastName: u?.lastName ?? u?.last_name ?? "",
    username: u?.username ?? "",
    email: u?.email ?? "",
    phone:
      u?.phone ??
      u?.phoneNumber ??
      u?.phone_number ??
      "",
    birthdate: toBirthdateString(u?.birthdate ?? u?.birthDate),
    gender: u?.gender ?? "",
    addressLine1: u?.addressLine1 ?? "",
    addressLine2: u?.addressLine2 ?? "",
    city: u?.city ?? "",
    province: u?.province ?? "",
    postalCode: u?.postalCode ?? "",
    // Resolve to an absolute URL so it works in all environments
    avatarUrl: getImageUrl(u?.avatarUrl ?? u?.avatar ?? u?.avatar_url ?? ""),
  };
}
